module.exports = __webpack_public_path__ + "img/event2412_6_2.166ef3a0.jpg";